import createIcon from '../../createIcon';

/**
 * @component @name Scoreboard
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcuNSAxNC41SDE2VjExLjVIMTcuNVYxNC41Wk0yMCA1SDE3VjNIMTVWNUg5VjNIN1Y1SDRDMi45IDUgMiA1LjkgMiA3VjE5QzIgMjAuMSAyLjkgMjEgNCAyMUgyMEMyMS4xIDIxIDIyIDIwLjEgMjIgMTlWN0MyMiA1LjkgMjEuMSA1IDIwIDVaTTkuNSAxMi41QzkuNSAxMy4wNSA5LjA1IDEzLjUgOC41IDEzLjVINi41VjE0LjVIOS41VjE2SDVWMTMuNUM1IDEyLjk1IDUuNDUgMTIuNSA2IDEyLjVIOFYxMS41SDVWMTBIOC41QzkuMDUgMTAgOS41IDEwLjQ1IDkuNSAxMVYxMi41Wk0xMi43NSAxOUgxMS4yNVYxNy41SDEyLjc1VjE5Wk0xMi43NSAxNS41SDExLjI1VjE0SDEyLjc1VjE1LjVaTTEyLjc1IDEySDExLjI1VjEwLjVIMTIuNzVWMTJaTTEyLjc1IDguNUgxMS4yNVY3SDEyLjc1VjguNVpNMTkgMTVDMTkgMTUuNTUgMTguNTUgMTYgMTggMTZIMTUuNUMxNC45NSAxNiAxNC41IDE1LjU1IDE0LjUgMTVWMTFDMTQuNSAxMC40NSAxNC45NSAxMCAxNS41IDEwSDE4QzE4LjU1IDEwIDE5IDEwLjQ1IDE5IDExVjE1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Scoreboard = createIcon('Scoreboard', [
  [
    'path',
    {
      d: 'M17.5 14.5H16V11.5H17.5V14.5ZM20 5H17V3H15V5H9V3H7V5H4C2.9 5 2 5.9 2 7V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V7C22 5.9 21.1 5 20 5ZM9.5 12.5C9.5 13.05 9.05 13.5 8.5 13.5H6.5V14.5H9.5V16H5V13.5C5 12.95 5.45 12.5 6 12.5H8V11.5H5V10H8.5C9.05 10 9.5 10.45 9.5 11V12.5ZM12.75 19H11.25V17.5H12.75V19ZM12.75 15.5H11.25V14H12.75V15.5ZM12.75 12H11.25V10.5H12.75V12ZM12.75 8.5H11.25V7H12.75V8.5ZM19 15C19 15.55 18.55 16 18 16H15.5C14.95 16 14.5 15.55 14.5 15V11C14.5 10.45 14.95 10 15.5 10H18C18.55 10 19 10.45 19 11V15Z',
      key: '1sea04',
    },
  ],
]);

export default Scoreboard;
